import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedPaymentType: null,
  paybyPaymentModalData: {
    isOpen: false,
    isLoading:false,
    data: null,
  },
  payByVirtualOrderId: null,
  refreshPaybyPaymentModalData: false,
  payByCreateIntent:{}
};

const PaymentMethod = createSlice({
  name: "payment_methods",
  initialState,
  reducers: {
    setSelectedPaymentType: (state, action) => {
      state.selectedPaymentType = action.payload;
    },
    setPaybyPaymentModalData: (state, action) => {
      state.paybyPaymentModalData = action.payload;
    },
    setPayByVirtualOrderId: (state, action) => {
      state.payByVirtualOrderId = action.payload;
    },
    resetPaybyPaymentModalData: (state) => {
      state.paybyPaymentModalData = initialState.paybyPaymentModalData;
    },
    setRefreshPaybyPaymentModalData: (state, action) => {
      state.refreshPaybyPaymentModalData = action.payload;
    },
    setPayByCreateIntent: (state, action) => {
      state.payByCreateIntent = action.payload;
    }
  },
});

export const { setSelectedPaymentType, setPaybyPaymentModalData, setPayByVirtualOrderId, resetPaybyPaymentModalData, setRefreshPaybyPaymentModalData, setPayByCreateIntent } = PaymentMethod.actions;

export default PaymentMethod.reducer;
